export const typeOptions = [
  {label: 'نقدی', value: 'cash'},
  {label: 'اعتباری', value: 'credit'},
];
